<template>
  <div class="CompanyCommonProblem">
    <div class="inner_center">
      <h2>常见问题</h2>
      <div class="problem-list">
        <div class="problem-item">
          <div class="problem-title">
            01、个人VIP和企业VIP有什么区别？
          </div>
          <div class="problem-content">
            企业VIP主要面向有组织架构的公司/企业，用于商业授权使用，企业VIP服务包含侵权赔付保障及专属客服支持。个人VIP面向个人用户，仅限学习交流使用。
          </div>
        </div>

        <div class="problem-item">
          <div class="problem-title">
            02、如何申请发票？
          </div>
          <div class="problem-content">
            企业VIP进入企业服务，左侧栏【充值记录】里申请电子发票。
          </div>
        </div>

        <div class="problem-item">
          <div class="problem-title">
            03、已经购买企业VIP，子账号/主体数量不够可以再增加吗？
          </div>
          <div class="problem-content">
            1.当您服务的一家主体需要多个子账号下载图片，子账号不够时，可在企业服务 选择对应主体加购子账号数量。 <br>
            2.当您需要增加企业主体时，可直接在前台选购企业VIP版本，支付成功进入 企业服务填写企业名称，即可下载企业授权书。
          </div>
        </div>

        <div class="problem-item">
          <div class="problem-title">
            04、我是乙方设计公司服务多家甲方，可以只买一个企业授权吗？会侵权吗？
          </div>
          <div class="problem-content">
            这样算侵权行为。服务多家甲方公司，您可以购买企业多主体VIP，服务几个甲方购买几个主体，为您服务的每一家甲方公司购买企业授权并下载授权书。既为甲方公司提供版权保障，也为您乙方公司降低侵权风险。
          </div>
        </div>

        <div class="problem-item">
          <div class="problem-title">
            05、在哪里可以续费企业VIP？
          </div>
          <div class="problem-content">
            1.通过导航栏【企业授权】选择版本直接购买。<br>
            2.进入企业服务-左侧栏【续费/加购】直接选择主体延长时间。 <br>
          </div>
        </div>

        <div class="problem-item">
          <div class="problem-title">
            06、如何判断公司规模是大/中/小/微型企业？
          </div>
          <div class="problem-content">
            <!--            基于大数据模型，公司人数只是参考，应结合不同行业企业的经营数据。点击查看大中小微企业划分办法
                        <a href="http://www.stats.gov.cn/sj/tjbz/gjtjbz/202302/t20230213_1902763.html" target="_blank">http://www.stats.gov.cn/sj/tjbz/gjtjbz/202302/t20230213_1902763.html</a>
                      -->
            1.遵循国家工信部与发改委标准，按从业人员和营收规模划分中小微企业和大型企业。详见：
            <a href="http://www.stats.gov.cn/sj/tjbz/gjtjbz/202302/t20230213_1902763.html" target="_blank">《关于印发中小企业划分型标准规定的通知》</a>。<br>
            2.「企业商用VIP」仅针对中小微企业开放，且有授权范围约束，请仔细核对是否支持贵公司使用。 <br>
            3.面向大型企业/集团公司/政务事业单位/跨国公司开放，以及「企业商业VIP」不能满足的授权范围，须订购「企业商用PLUS」与「定制」服务套餐。有更加开放、灵活定制、全用途授权、更多团队管理协同功能的服务方案。
            <a :href="SERVICE_LINK" target="_blank">咨询在线企业客户顾问</a>。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {SERVICE_LINK} from "@/constant/_Public/Path";

export default {
  name: "CompanyCommonProblem",
  data() {
    return {
      SERVICE_LINK
    }
  }
}
</script>

<style lang="scss" scoped>
.CompanyCommonProblem {

  h2 {
    font-weight: bold;
    color: #2D2B33;
    letter-spacing: 1px;
    text-align: center;
    padding-top: 56px;
    font-size: 32px;
    line-height: 42px;
  }

  .problem-list {
    display: flex;
    flex-wrap: wrap;
    //align-items: center;
    justify-content: center;
    margin: 64px auto 40px;

    .problem-item {
      width: 540px;
      margin-bottom: 40px;
      margin-right: 120px;

      &:nth-child(2n) {
        margin-right: 0;
      }

      .problem-title {
        font-size: 20px;
        font-weight: bold;
        color: #0A2540;
        line-height: 27px;
        letter-spacing: 1px;
        margin-bottom: 16px;
      }

      .problem-content {
        font-size: 14px;
        color: #596088;
        line-height: 24px;

        .service {
          font-size: 14px;
          color: #6969FF;
          line-height: 24px;
          text-decoration: underline;
        }

        a {
          word-break: break-all; /* 允许在单词内换行 */
          color: $color-primary;
        }
      }
    }

  }
}
</style>
